import PropTypes from 'prop-types';
import moment from 'moment';

import ValidatingForm from '../forms/validating_form';

class OrdinationPage extends ValidatingForm {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      return: false,
      redirect: false,
    });

    this.back = this.back.bind(this);
    this.submit = this.submit.bind(this);
  }

  today() {
    return moment().format('dddd MMMM Do, YYYY');
  }

  back(e) {
    e.preventDefault();

    this.setState({
      return: true
    });
  }

  submit(e) {
    e.preventDefault();

    this.setState({
      redirect: this.isValid()
    });
  }
}

OrdinationPage.propTypes = {
  minister: PropTypes.object.isRequired,
};

export default OrdinationPage;
